var text_field_default = {
  "root": "_8pmfm",
  "text": "Ako1Z",
  "input": "xTBMt",
  "small": "_17yFM",
  "medium": "sK6FM",
  "large": "_9hYIX",
  "webview": "fgKaE",
  "endAdornment": "zKjkq",
  "shown": "v8eB2",
  "value": "fTNIs",
  "spinner": "jiefX",
  "spin": "NQYVn"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
